import { useState } from "react";
import { FaArrowLeft, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AddPurchase = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    invoiceNo: "#000000",
    vendorName: "",
    purchaseDate: "",
    expiryDate: "",
    itemName: "",
    quantity: "",
    notes: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    console.log("Submitted Purchase:", form);
    navigate("/"); // redirect or save logic
  };

  return (
    <div className="min-h-screen bg-[#f9f9f9] flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-white shadow">
        <button onClick={() => navigate(-1)} className="text-gray-600">
          <FaArrowLeft />
        </button>
        <h1 className="text-lg font-semibold text-gray-800">Add Purchase</h1>
        <button onClick={handleSubmit} className="text-primary">
          <FaCheck />
        </button>
      </div>

      {/* Form */}
      <div className="flex-1 px-4 py-6 space-y-5">
        {/* Invoice No */}
        <div>
          <label className="text-sm font-medium text-gray-600">Invoice No*</label>
          <input
            type="text"
            name="invoiceNo"
            value={form.invoiceNo}
            onChange={handleChange}
            className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-1 text-sm"
            readOnly
          />
        </div>

        {/* Vendor Name */}
        <div>
          <label className="text-sm font-medium text-gray-600">Vendor Name*</label>
          <select
            name="vendorName"
            value={form.vendorName}
            onChange={handleChange}
            className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-1 text-sm"
          >
            <option value="">Select Vendor</option>
            <option value="John Doe">John Doe</option>
            <option value="Jane Smith">Jane Smith</option>
          </select>
        </div>

        {/* Purchase + Expiry Dates */}
        <div className="flex gap-3">
          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">Purchase Date*</label>
            <input
              type="date"
              name="purchaseDate"
              value={form.purchaseDate}
              onChange={handleChange}
              className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-1 text-sm"
            />
          </div>
          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">Expiry Date</label>
            <input
              type="date"
              name="expiryDate"
              value={form.expiryDate}
              onChange={handleChange}
              className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-1 text-sm"
            />
          </div>
        </div>

        {/* Item Info */}
        <div>
          <label className="text-sm font-medium text-gray-600">Item Information*</label>
          <input
            type="text"
            name="itemName"
            value={form.itemName}
            onChange={handleChange}
            placeholder="Enter Item Name"
            className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-1 text-sm"
          />
          <input
            type="text"
            name="quantity"
            value={form.quantity}
            onChange={handleChange}
            placeholder="Enter Quantity"
            className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-2 text-sm"
          />
        </div>

        {/* Notes */}
        <div>
          <label className="text-sm font-medium text-gray-600">Notes</label>
          <textarea
            name="notes"
            value={form.notes}
            onChange={handleChange}
            placeholder="Enter Notes"
            rows={3}
            className="w-full bg-white px-4 py-3 rounded-md border border-gray-300 mt-1 text-sm resize-none"
          />
        </div>
      </div>

      {/* Submit Button */}
      <div className="px-4 py-4 bg-white shadow">
        <button
          onClick={handleSubmit}
          className="w-full bg-primary hover:bg-red-700 text-white py-3 rounded-md font-medium text-sm"
        >
          Sent Request
        </button>
      </div>
    </div>
  );
};

export default AddPurchase;
